import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(message) {
        this.y45_1 = message;
        this.z45_1 = null;
        this.a46_1 = null;
        this.b46_1 = null;
        this.c46_1 = null;
      }
      d46(locations) {
        // Inline function 'kotlin.apply' call
        this.z45_1 = locations;
        return this;
      }
      e46(path) {
        // Inline function 'kotlin.apply' call
        this.a46_1 = path;
        return this;
      }
      r40(extensions) {
        // Inline function 'kotlin.apply' call
        this.c46_1 = extensions;
        return this;
      }
      f46(nonStandardFields) {
        // Inline function 'kotlin.apply' call
        this.b46_1 = nonStandardFields;
        return this;
      }
      i37() {
        return new (Error_0())(this.y45_1, this.z45_1, this.a46_1, this.c46_1, this.b46_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocationClass;
function Location() {
  if (LocationClass === VOID) {
    class $ {
      constructor(line, column) {
        this.g46_1 = line;
        this.h46_1 = column;
      }
      toString() {
        return 'Location(line = ' + this.g46_1 + ', column = ' + this.h46_1 + ')';
      }
    }
    initMetadataForClass($, 'Location');
    LocationClass = $;
  }
  return LocationClass;
}
var ErrorClass;
function Error_0() {
  if (ErrorClass === VOID) {
    class $ {
      constructor(message, locations, path, extensions, nonStandardFields) {
        this.i46_1 = message;
        this.j46_1 = locations;
        this.k46_1 = path;
        this.l46_1 = extensions;
        this.m46_1 = nonStandardFields;
      }
      toString() {
        return 'Error(message = ' + this.i46_1 + ', locations = ' + toString(this.j46_1) + ', path=' + toString(this.k46_1) + ', extensions = ' + toString(this.l46_1) + ', nonStandardFields = ' + toString(this.m46_1) + ')';
      }
    }
    initMetadataForClass($, 'Error');
    ErrorClass = $;
  }
  return ErrorClass;
}
//region block: exports
export {
  Builder as Builder3gaff1pwujyid,
  Location as Location25t453jk43ktl,
};
//endregion

//# sourceMappingURL=Error.mjs.map
